import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Header.css';

// Логотип будет загружаться из public
const logoUrl = '/logo.png';

const LogoutIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 5H11C11.55 5 12 4.55 12 4C12 3.45 11.55 3 11 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H11C11.55 21 12 20.55 12 20C12 19.45 11.55 19 11 19H5V5Z" fill="currentColor"/>
    <path d="M20.65 11.65L17.86 8.86C17.54 8.54 17 8.76 17 9.21V11H10C9.45 11 9 11.45 9 12C9 12.55 9.45 13 10 13H17V14.79C17 15.24 17.54 15.46 17.85 15.14L20.64 12.35C20.84 12.16 20.84 11.84 20.65 11.65Z" fill="currentColor"/>
  </svg>
);

const CloseIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const Header = ({ activeNav = 'auth' }) => {
  const navigate = useNavigate();
  const { isAuthenticated, logout } = useAuth();
  const [isPrivacyPopupOpen, setIsPrivacyPopupOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/auth');
  };

  const openPrivacyPopup = (e) => {
    e.preventDefault();
    setIsPrivacyPopupOpen(true);
  };

  const closePrivacyPopup = () => {
    setIsPrivacyPopupOpen(false);
  };

  return (
    <>
      <header className="header">
        <div className="header__container">
          <div className="header__panel">
            {/* Логотип */}
            <div className="header__logo" onClick={() => navigate('/orders')} role="button" tabIndex={0}>
              <img src={logoUrl} alt="Go Play Donate" className="header__logo-img" draggable="false" />
            </div>
            
            {/* Навигация - Desktop */}
            <nav className="header__nav header__nav--desktop">
              <div className="header__divider" />
              {activeNav === 'profile' ? (
                <a 
                  href="/profile" 
                  className="header__nav-link header__nav-link--active"
                >
                  Профиль
                </a>
              ) : (
                <a 
                  href="/auth" 
                  className={`header__nav-link ${activeNav === 'auth' ? 'header__nav-link--active' : ''}`}
                >
                  Профиль
                </a>
              )}
              <div className="header__divider" />
              <a 
                href="https://vk.com/topic-225634454_50615327" 
                target="_blank"
                rel="noopener noreferrer"
                className={`header__nav-link ${activeNav === 'reviews' ? 'header__nav-link--active' : ''}`}
              >
                Отзывы
              </a>
              <div className="header__divider" />
              <a 
                href="#privacy" 
                className={`header__nav-link ${activeNav === 'privacy' ? 'header__nav-link--active' : ''}`}
                onClick={openPrivacyPopup}
              >
                Политика конфиденциальности
              </a>
              <div className="header__divider" />
            </nav>
            
            {/* Навигация - Mobile */}
            <nav className="header__nav header__nav--mobile">
              <div className="header__divider" />
              {activeNav === 'profile' ? (
                <a 
                  href="/profile" 
                  className="header__nav-link header__nav-link--active"
                >
                  Профиль
                </a>
              ) : (
                <a 
                  href="/auth" 
                  className="header__nav-link"
                >
                  Профиль
                </a>
              )}
              <div className="header__divider" />
              <a 
                href="https://vk.com/topic-225634454_50615327" 
                target="_blank"
                rel="noopener noreferrer"
                className="header__nav-link"
              >
                Отзывы
              </a>
              <div className="header__divider" />
              <a 
                href="#privacy" 
                className="header__nav-link"
                onClick={openPrivacyPopup}
              >
                Политика
              </a>
              <div className="header__divider" />
            </nav>
            
            {/* Кнопка выхода */}
            {isAuthenticated && (
              <button 
                className="header__logout" 
                onClick={handleLogout}
                aria-label="Выйти из аккаунта"
                title="Выйти из аккаунта"
              >
                <LogoutIcon />
              </button>
            )}
          </div>
        </div>
      </header>

      {/* Privacy Policy Popup */}
      {isPrivacyPopupOpen && (
        <div className="privacy-popup-overlay" onClick={closePrivacyPopup}>
          <div className="privacy-popup" onClick={(e) => e.stopPropagation()}>
            <div className="privacy-popup__header">
              <h2 className="privacy-popup__title">Политика конфиденциальности</h2>
              <button 
                className="privacy-popup__close" 
                onClick={closePrivacyPopup}
                aria-label="Закрыть"
              >
                <CloseIcon />
              </button>
            </div>
            <div className="privacy-popup__content">
              <section className="privacy-popup__section">
                <p>Настоящая Политика конфиденциальности (далее — «Политика») определяет порядок обработки и защиты персональной информации пользователей веб-сайта <a href="http://goplay-cabinet.ru" target="_blank" rel="noopener noreferrer">goplay-cabinet.ru</a> (далее — «Сайт»), предоставляемой пользователями Обществу с ограниченной ответственностью «Глобал Бридж» (ИНН: 9909704508), далее именуемому «Оператор».</p>
              </section>

              <section className="privacy-popup__section">
                <h3>1. ОБЩИЕ ПОЛОЖЕНИЯ</h3>
                <p><strong>1.1.</strong> Настоящая Политика разработана в соответствии с требованиями применимого законодательства о защите персональных данных и определяет порядок обработки персональных данных и меры по обеспечению их безопасности.</p>
                <p><strong>1.2.</strong> Цель настоящей Политики — обеспечение надлежащей защиты персональных данных пользователей от несанкционированного доступа и раскрытия.</p>
                <p><strong>1.3.</strong> Используя Сайт, пользователь выражает свое согласие с условиями настоящей Политики и дает согласие на обработку своих персональных данных на условиях, изложенных в настоящей Политике.</p>
                <p><strong>1.4.</strong> Если пользователь не согласен с условиями Политики, он должен незамедлительно прекратить использование Сайта.</p>
                <p><strong>1.5.</strong> Настоящая Политика применяется только к Сайту <a href="http://goplay-cabinet.ru" target="_blank" rel="noopener noreferrer">goplay-cabinet.ru</a>. Оператор не контролирует и не несет ответственность за сайты третьих лиц, на которые пользователь может перейти по ссылкам, доступным на Сайте.</p>
              </section>

              <section className="privacy-popup__section">
                <h3>2. ТЕРМИНЫ И ОПРЕДЕЛЕНИЯ</h3>
                <p><strong>2.1.</strong> В настоящей Политике используются следующие термины:</p>
                <p><strong>Персональные данные</strong> — любая информация, относящаяся к прямо или косвенно определенному или определяемому физическому лицу (субъекту персональных данных).</p>
                <p><strong>Обработка персональных данных</strong> — любое действие (операция) или совокупность действий (операций), совершаемых с использованием средств автоматизации или без использования таких средств с персональными данными, включая сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (распространение, предоставление, доступ), обезличивание, блокирование, удаление, уничтожение персональных данных.</p>
                <p><strong>Автоматизированная обработка персональных данных</strong> — обработка персональных данных с помощью средств вычислительной техники.</p>
                <p><strong>Оператор</strong> — ОсОО «Глобал Бридж» (ИНН: 9909704508), самостоятельно или совместно с другими лицами организующий и (или) осуществляющий обработку персональных данных, а также определяющий цели обработки персональных данных, состав персональных данных, подлежащих обработке, действия (операции), совершаемые с персональными данными.</p>
                <p><strong>Пользователь</strong> — физическое лицо, использующее Сайт.</p>
                <p><strong>Сайт</strong> — веб-сайт, расположенный в сети Интернет по адресу: <a href="http://goplay-cabinet.ru" target="_blank" rel="noopener noreferrer">goplay-cabinet.ru</a>.</p>
                <p><strong>Cookies</strong> — небольшие файлы, отправляемые Сайтом и хранящиеся на устройстве пользователя.</p>
              </section>

              <section className="privacy-popup__section">
                <h3>3. ПРАВОВЫЕ ОСНОВАНИЯ ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ</h3>
                <p><strong>3.1.</strong> Оператор обрабатывает персональные данные пользователя на основании:</p>
                <p>— Применимого законодательства о защите персональных данных;</p>
                <p>— Согласия пользователя на обработку персональных данных, выраженного посредством использования Сайта и совершения конклюдентных действий.</p>
              </section>

              <section className="privacy-popup__section">
                <h3>4. СОСТАВ СОБИРАЕМОЙ ИНФОРМАЦИИ</h3>
                <p><strong>4.1.</strong> При использовании Сайта Оператор не собирает и не хранит персональные данные пользователей в собственных базах данных.</p>
                <p><strong>4.2.</strong> Сайт может временно обрабатывать следующие технические данные, необходимые для функционирования веб-сервиса:</p>
                <p>— IP-адрес пользователя;</p>
                <p>— Информация о браузере и операционной системе;</p>
                <p>— Данные о посещенных страницах Сайта;</p>
                <p>— Время доступа к Сайту;</p>
                <p>— Файлы cookies.</p>
                <p><strong>4.3.</strong> При оформлении заказа на Сайте могут потребоваться следующие данные:</p>
                <p>— Игровой логин или ID;</p>
                <p>— Данные для входа в игровой аккаунт (электронная почта и/или пароль);</p>
                <p>— Контактная информация для связи (по желанию пользователя).</p>
                <p><strong>4.4.</strong> Важно: Указанные в п. 4.3 данные не сохраняются на серверах Оператора и используются исключительно для исполнения заказа пользователя. После завершения сделки все данные автоматически удаляются.</p>
              </section>

              <section className="privacy-popup__section">
                <h3>5. ЦЕЛИ ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ</h3>
                <p><strong>5.1.</strong> Временная обработка данных осуществляется исключительно с целью:</p>
                <p>— Обеспечения функционирования Сайта;</p>
                <p>— Исполнения заказов пользователей;</p>
                <p>— Обеспечения обратной связи и технической поддержки;</p>
                <p>— Улучшения качества предоставляемых услуг;</p>
                <p>— Выполнения требований применимого законодательства.</p>
                <p><strong>5.2.</strong> Оператор не использует персональные данные для:</p>
                <p>— Создания баз данных пользователей;</p>
                <p>— Рассылки рекламных и маркетинговых материалов без согласия пользователя;</p>
                <p>— Передачи, продажи или обмена данными с третьими лицами в коммерческих целях.</p>
              </section>

              <section className="privacy-popup__section">
                <h3>6. ОБРАБОТКА И ХРАНЕНИЕ ДАННЫХ</h3>
                <p><strong>6.1.</strong> Обработка персональных данных осуществляется на законной и справедливой основе.</p>
                <p><strong>6.2.</strong> Оператор обрабатывает персональные данные исключительно в режиме реального времени для обеспечения функционирования Сайта и исполнения заказов.</p>
                <p><strong>6.3.</strong> Персональные данные не хранятся на серверах Оператора. Данные, предоставленные пользователем при оформлении заказа, используются исключительно для выполнения заказа и удаляются сразу после завершения сделки.</p>
                <p><strong>6.4.</strong> Технические данные (логи сервера, cookies) могут храниться в течение времени, необходимого для обеспечения безопасности и стабильности работы Сайта, но не более 30 (тридцати) дней, после чего автоматически удаляются.</p>
                <p><strong>6.5.</strong> Обработка персональных данных осуществляется с использованием средств автоматизации.</p>
              </section>

              <section className="privacy-popup__section">
                <h3>7. ПЕРЕДАЧА ИНФОРМАЦИИ ТРЕТЬИМ ЛИЦАМ</h3>
                <p><strong>7.1.</strong> Оператор не передает, не продает и не обменивает персональные данные пользователей третьим лицам.</p>
                <p><strong>7.2.</strong> Единственным исключением является передача данных по официальному запросу уполномоченных государственных органов в случаях, предусмотренных применимым законодательством.</p>
                <p><strong>7.3.</strong> Все данные, необходимые для исполнения заказа, обрабатываются исключительно Оператором и не передаются никаким третьим лицам, включая платежные системы, партнерские сервисы или иные организации.</p>
              </section>

              <section className="privacy-popup__section">
                <h3>8. ТЕХНОЛОГИЯ COOKIES</h3>
                <p><strong>8.1.</strong> Сайт использует технологию cookies для улучшения функциональности и удобства использования.</p>
                <p><strong>8.2.</strong> Cookies представляют собой небольшие текстовые файлы, которые сохраняются на устройстве пользователя при посещении Сайта.</p>
                <p><strong>8.3.</strong> Cookies используются для:</p>
                <p>— Обеспечения корректной работы функций Сайта;</p>
                <p>— Сохранения пользовательских настроек;</p>
                <p>— Анализа статистики посещаемости (обезличенные данные).</p>
                <p><strong>8.4.</strong> Пользователь может отключить использование cookies в настройках своего браузера. Однако это может привести к ограничению функциональности Сайта.</p>
                <p><strong>8.5.</strong> Информация, собираемая с помощью cookies, не содержит персональных данных и не может быть использована для идентификации конкретного пользователя.</p>
              </section>

              <section className="privacy-popup__section">
                <h3>9. ЗАЩИТА ДАННЫХ</h3>
                <p><strong>9.1.</strong> Оператор принимает все необходимые организационные и технические меры для защиты персональных данных от неправомерного или случайного доступа, уничтожения, изменения, блокирования, копирования, распространения, а также от иных неправомерных действий третьих лиц.</p>
                <p><strong>9.2.</strong> К мерам защиты относятся:</p>
                <p>— Использование защищенного протокола передачи данных (HTTPS/SSL);</p>
                <p>— Ограничение доступа к техническим средствам обработки данных;</p>
                <p>— Применение средств антивирусной защиты;</p>
                <p>— Регулярное резервное копирование системных настроек;</p>
                <p>— Мониторинг безопасности и своевременное обновление программного обеспечения.</p>
                <p><strong>9.3.</strong> Учитывая, что Оператор не хранит персональные данные пользователей, риски несанкционированного доступа к таким данным минимизированы.</p>
              </section>

              <section className="privacy-popup__section">
                <h3>10. ПРАВА ПОЛЬЗОВАТЕЛЯ</h3>
                <p><strong>10.1.</strong> Пользователь имеет право:</p>
                <p><strong>10.1.1.</strong> Получать информацию, касающуюся обработки его персональных данных, в том числе содержащую:</p>
                <p>— Подтверждение факта обработки персональных данных Оператором;</p>
                <p>— Правовые основания и цели обработки персональных данных;</p>
                <p>— Сведения о лицах, которые имеют доступ к персональным данным.</p>
                <p><strong>10.1.2.</strong> Требовать уточнения своих персональных данных, их блокирования или уничтожения в случае, если персональные данные являются неполными, устаревшими, неточными, незаконно полученными или не являются необходимыми для заявленной цели обработки.</p>
                <p><strong>10.1.3.</strong> Отозвать свое согласие на обработку персональных данных путем направления соответствующего уведомления Оператору.</p>
                <p><strong>10.1.4.</strong> Обжаловать действия или бездействие Оператора в уполномоченный орган по защите прав субъектов персональных данных или в судебном порядке.</p>
                <p><strong>10.1.5.</strong> Получить возмещение убытков и (или) компенсацию морального вреда в судебном порядке в случае нарушения Оператором требований законодательства о персональных данных.</p>
                <p><strong>10.2.</strong> Для реализации своих прав пользователь может обратиться к Оператору по контактным данным, указанным в разделе 13 настоящей Политики.</p>
                <p><strong>10.3.</strong> Обращаем внимание: в связи с тем, что Оператор не хранит персональные данные пользователей, запросы на уточнение, изменение или удаление данных могут быть неприменимы, поскольку данные автоматически удаляются после завершения каждой сделки.</p>
              </section>

              <section className="privacy-popup__section">
                <h3>11. ОБРАБОТКА ПЕРСОНАЛЬНЫХ ДАННЫХ НЕСОВЕРШЕННОЛЕТНИХ</h3>
                <p><strong>11.1.</strong> Сайт не предназначен для использования лицами, не достигшими 18 лет.</p>
                <p><strong>11.2.</strong> Оператор не осуществляет сбор персональных данных несовершеннолетних без согласия их законных представителей.</p>
                <p><strong>11.3.</strong> Если Оператору станет известно, что персональные данные были получены от лица, не достигшего 18 лет, без соответствующего согласия законных представителей, такие данные будут незамедлительно удалены.</p>
              </section>

              <section className="privacy-popup__section">
                <h3>12. ИЗМЕНЕНИЯ ПОЛИТИКИ КОНФИДЕНЦИАЛЬНОСТИ</h3>
                <p><strong>12.1.</strong> Оператор оставляет за собой право вносить изменения в настоящую Политику конфиденциальности в одностороннем порядке.</p>
                <p><strong>12.2.</strong> Новая редакция Политики вступает в силу с момента ее размещения на Сайте, если иное не предусмотрено новой редакцией Политики.</p>
                <p><strong>12.3.</strong> Актуальная версия Политики всегда доступна на Сайте по адресу: <a href="http://goplay-cabinet.ru/privacy" target="_blank" rel="noopener noreferrer">goplay-cabinet.ru/privacy</a></p>
                <p><strong>12.4.</strong> Продолжение использования Сайта после внесения изменений в Политику означает согласие пользователя с такими изменениями.</p>
              </section>

              <section className="privacy-popup__section">
                <h3>13. КОНТАКТНАЯ ИНФОРМАЦИЯ</h3>
                <p><strong>13.1.</strong> По всем вопросам, связанным с обработкой персональных данных и настоящей Политикой конфиденциальности, пользователь может обратиться к Оператору:</p>
                <div className="privacy-popup__contacts">
                  <p><strong>ОсОО «Глобал Бридж»</strong></p>
                  <p><strong>ОГРН:</strong> 309678-3301-ООО</p>
                  <p><strong>ИНН:</strong> 9909704508</p>
                  <p><strong>Адрес:</strong> Кыргызская Республика, г. Бишкек, Октябрьский район, улица Юнусалиева 185/1</p>
                  <p><strong>E-mail:</strong> <a href="mailto:gooplaydonate@gmail.com">gooplaydonate@gmail.com</a></p>
                  <p><strong>Поддержка в Telegram:</strong> <a href="https://t.me/GoPlayDonateSupport" target="_blank" rel="noopener noreferrer">@GoPlayDonateSupport</a></p>
                </div>
                <p><strong>13.2.</strong> Оператор обязуется рассмотреть и ответить на обращение пользователя в течение 30 (тридцати) дней с момента получения обращения.</p>
              </section>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
